import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

interface TransferProgressModalProps {
    isOpen: boolean;
    progress: number;
    isComplete: boolean;
    itemCount: number;
    onClose: () => void;
}

const TransferProgressModal: React.FC<TransferProgressModalProps> = ({
    isOpen,
    progress,
    isComplete,
    itemCount,
    onClose
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div className="sm:flex sm:items-start">
                            <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                                <div className="flex justify-between items-center">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                        {isComplete ? 'Transfer Complete' : 'Transferring Items'}
                                    </h3>
                                    {isComplete && (
                                        <button
                                            className="text-gray-400 hover:text-gray-500"
                                            onClick={onClose}
                                        >
                                            <XMarkIcon className="h-5 w-5" />
                                        </button>
                                    )}
                                </div>
                                
                                <div className="mt-4">
                                    {isComplete ? (
                                        <div className="flex flex-col items-center justify-center py-4">
                                            <CheckCircleIcon className="h-12 w-12 text-green-500 mb-4" />
                                            <p className="text-sm text-gray-500">
                                                Successfully transferred {itemCount} items
                                            </p>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4">
                                                <div 
                                                    className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-in-out" 
                                                    style={{ width: `${progress}%` }}
                                                ></div>
                                            </div>
                                            <p className="text-sm text-gray-500">
                                                Transferring shared items... {Math.round(progress)}%
                                            </p>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {isComplete && (
                        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                            <button
                                type="button"
                                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
                                onClick={onClose}
                            >
                                Close
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TransferProgressModal;